import WorkersChart from './WorkersChart';

export default WorkersChart;
